import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import MeetMePage from "./pages/MeetMePage";
import PersonalStylingPage from "./pages/PersonalStylingPage";
import InteriorDesignPage from "./pages/InteriorDesignPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/meet-me" element={<MeetMePage />} />
            <Route path="/personal-styling" element={<PersonalStylingPage />} />
            <Route path="/interior-design" element={<InteriorDesignPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
